export default __webpack_public_path__ + "static/media/section2-5-img1.a57b7c06.png";